import * as React from 'react';
import { FC } from 'react';
import withWidth, { WithWidthProps } from '../../../../hoc/withWidth';
import classNames from 'classnames';

interface VerticalGapProps extends WithWidthProps {
    chosenInsuranceName?: string;
}

const MobileVerticalBreak: FC<VerticalGapProps> = props => {
    const renderView = () => (
        <div className={'display-flex'}>
            <div
                className={classNames('okq8-mobile-vertical-break-card', {
                    ' okq8-page-background-color':
                        props.chosenInsuranceName === 'Trafikförsäkring'
                })}
            />
            <div className={'okq8-mobile-vertical-break-gap'} />
            <div
                className={classNames('okq8-mobile-vertical-break-card', {
                    ' okq8-page-background-color':
                        props.chosenInsuranceName === 'Halvförsäkring'
                })}
            />
            <div className={'okq8-mobile-vertical-break-gap'} />
            <div
                className={classNames('okq8-mobile-vertical-break-card', {
                    ' okq8-page-background-color':
                        props.chosenInsuranceName === 'Helförsäkring'
                })}
            />
        </div>
    );

    return renderView();
};

export default withWidth<VerticalGapProps>(MobileVerticalBreak);
